import React = require("react")
import { ApiResult } from "../api/apiTypes"

interface AnnouncementProps {
  readonly showAnnouncement?: boolean
  readonly announcement?: string
}

export const Announcement = (props: { homepage: ApiResult<AnnouncementProps> }) => {
  const home = props.homepage
  if (home == 'loading' || home == 'error' || !home.announcement || !home.showAnnouncement) return <></>

  return <div className="announcement" role="alert">
    <div className="container--mg align--center">
      <div className="announcement__inner text--styled" dangerouslySetInnerHTML={{ __html: home.announcement }} />
    </div>
  </div>
}
